import { Container, Col, Row } from "react-bootstrap";
import SectionHeading from "../ui/SectionHeading";
import { Reveal, RevealGroup, RevealItem } from "../ui/Reveal";
import "../style/ThreeCrossTwo.css";

const GALLERY_STRIP = [
  { src: "images/gallery/bbcamp1.JPG", alt: "Guests enjoying breakfast at Kote Cafe" },
  { src: "images/idc.png", alt: "Kote Cafe storefront" },
  { src: "images/idcdosa.png", alt: "Fresh dosa served hot off the tawa" },
];

const ThreeCrossTwo = () => {
  return (
    <section className="section-pad camp-story">
      <Container className="container-narrow">
        <SectionHeading
          eyebrow="Our Story"
          title="A Family Table, Now Open to You"
          subtitle="What started as home cooking for our own family has grown into Bagalkot's neighborhood spot for the real thing."
        />

        <Row className="camp-story__intro align-items-center g-4">
          <Col lg={5}>
            <Reveal>
              <img
                src="images/gallery/campstory.png"
                alt="Guests sharing a meal together at Kote Cafe"
                className="camp-story__family-img"
              />
            </Reveal>
          </Col>
          <Col lg={7}>
            <Reveal className="camp-story__copy">
              <p>
                Step into the flavorful world of Kote Cafe, where the menu
                is built around one thing done right: soft idlis and crisp,
                golden dosas, served the way they're made at home.
              </p>
              <p>
                No shortcuts, no fillers — just batter ground the traditional
                way, cooked fresh to order, and served with the same care
                we'd give family.
              </p>
            </Reveal>
          </Col>
        </Row>

        <Reveal className="camp-story__quote-wrap">
          <blockquote className="camp-story__quote">
            <p>
              "Food may be essential as fuel for the body, but good food is
              fuel for the soul."
            </p>
            <cite>— Malcolm Forbes</cite>
          </blockquote>
        </Reveal>

        <RevealGroup className="row g-3 camp-story__gallery">
          {GALLERY_STRIP.map(({ src, alt }, i) => (
            <Col sm={4} key={src}>
              <RevealItem delay={i * 80} className="camp-story__photo card-surface">
                <img src={src} alt={alt} />
              </RevealItem>
            </Col>
          ))}
        </RevealGroup>
      </Container>
    </section>
  );
};

export default ThreeCrossTwo;
